import * as React from 'react';
import { useContext } from 'react';
import styled from 'styled-components';

import { AccountLink } from '@/lib/navigation';
import { UserInfoContext } from '../../../user/user-info';
import ChevronLeftIcon from '../../../../../images/chevron-left.svg';

const ChevronLeft = styled.img`
  width: 40px;
  position: absolute;
  top: 30px;
  z-index: 101;
`;

export const TicketBackButton = () => {
  const { inboxEnabled } = useContext(UserInfoContext);

  const accountLinkClassName = 'mobile noselect back-button';
  const accountLinkPath = inboxEnabled ? 'inbox' : 'tickets';

  return (
    <AccountLink tryBack path={accountLinkPath}>
      <div className={accountLinkClassName}>
        <ChevronLeft src={ChevronLeftIcon} alt="Back" />
      </div>
    </AccountLink>
  );
};
